import { PagingResults } from '@totem/types/common';

export interface BillingRate {
  id: string;
  type: string;
  name: string;
  email: string;
  department: string;
  departmentLead: boolean;
  billingRate: number;
  hourlyCost: number;
  availableHours: number;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
}

export interface BillingRatesReport {
  billingRates: BillingRate[];
  paging: PagingResults;
}

export interface AddEditBillingRate {
  id: string;
  name: string;
  type: string;
  email: string;
  department: string;
  departmentLead: boolean;
  billingRate: number;
  hourlyCost: number;
  availableHours: number;
}

export const getNewBillingRateData = (): AddEditBillingRate => {
  return {
    id: '',
    name: '',
    department: '',
    departmentLead: false,
    type: '',
    email: '',
    billingRate: 0,
    hourlyCost: 0,
    availableHours: 40,
  };
};

export interface FormErrors {
  name?: string;
  email?: string;
  billingRate?: string;
  hourlyCost?: string;
}
